import moment from 'moment';
import Box from '@mui/material/Box';
import { PropTypes } from 'prop-types';
import { getWeekday } from '../../utils/CommonFunctions';
import logo from '../images/logo.png';
import { ChatWrapperCss as WrapperCss } from '../../utils/WrapperCss';
import { ORIENTAL_BANK_LOGO } from '../../Constants';

const ChatLogo = (props) => {
  const { englishBot } = props;
  return (
    <>
      <Box component="div" sx={WrapperCss.logo_container}>
        <img src={logo} alt={ORIENTAL_BANK_LOGO} width="70" height="70" tabIndex="101" />
      </Box>
      <Box component="div" sx={WrapperCss.today_date}>
        <span>
          {getWeekday(englishBot)}
          {moment().format(', h:mm A')}
        </span>
      </Box>
    </>
  );
};
ChatLogo.propTypes = {
  englishBot: PropTypes.bool,
};
export default ChatLogo;
